{
  "projectId": "shdeed-prod",
  "apiBaseUrl": "https://us-central1-shdeed-prod.cloudfunctions.net",
  "storageBucket": "shdeed-prod.firebasestorage.app",
  "org-admin": {
    "appId": "1:115888183522:web:cbb4653a9c0ce2c8a326bb",
    "authDomain": "admin.shdeed.com",
    "siteKey": "6LdmLNgtAAAAACVMsHONHqq-aZY80cCySRpv8iUY"
  },
  "platform-console": {
    "appId": "1:115888183522:web:c39dee1fcf1bb85fa326bb",
    "authDomain": "console.shdeed.com",
    "siteKey": "6Lc-F9gtAAAAACd296BDTv1IneUb7tC-4oQ_uuLT"
  }
}
